<template>

    <div class="ui-checkbox" :class="{ disabled }">

        <input
            type="checkbox" :id="resolvedId" :name="name" :value="checkboxValue" :disabled="disabled"
            v-model="innerValue" @change.stop="onChange"/>

        <label :for="resolvedId">
            <div></div>
            <span v-if="$slots.default"><slot></slot></span>
        </label>

    </div>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin, innerValueMixin, uuid } from '@wittignl/js-core';

@Component({
    name: 'ui-checkbox',
    mixins: [innerValueMixin],
    emits: ['update:modelValue', 'change']
})
export default class Checkbox extends Vue {

    @Prop({ type: [Boolean, Array] })
    modelValue: boolean|any[];

    @Prop({ type: [String, Number] })
    checkboxValue: string|number;

    @Prop({ type: String })
    name: string;

    @Prop({ type: String })
    id: string;

    @Prop({ type: Boolean })
    disabled: boolean;

    uniqueId: string

    created() {

        this.uniqueId = uuid();
    }

    onChange(e) {

        this.$emit('change', this.innerValue, e);
    }

    get resolvedId() {

        if(this.id){
            return this.id;
        }

        const idParts = ['checkbox'];

        if(this.name){
            idParts.push(this.name);
        }

        idParts.push(this.uniqueId);

        return idParts.join('_');
    }
}

export type CheckboxComp = InstanceType<typeof Checkbox>
export type CheckboxProps = ComponentProps<CheckboxComp>
export const checkboxCompMixin = createComponentMixin(Checkbox)

</script>
<style src="../../../scss/component/control/Checkbox.scss" lang="scss"></style>